var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import useStateWithMutators from '@rad/hooks/useStateWithMutators';
import Button from './button';
export default (props) => {
    const [state, mutators] = useStateWithMutators({
        'loading': false
    });
    const click = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            mutators.loading(true);
            yield props.onClick();
        }
        finally {
            mutators.loading(false);
        }
    });
    return _jsx(_Fragment, { children: _jsx(Button, Object.assign({}, props, { disabled: props.disabled || state.loading, onClick: click, children: state.loading ? _jsx(_Fragment, { children: _jsx("span", { className: "spinner-border spinner-border-sm", role: "status", style: { 'fontSize': 'inherit' }, children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) })
                : props.children })) });
};
